import type { ReactNode } from 'react';

import type { FragmentType } from '@e-socna/data-layer';

import { OrganizationMembershipCard } from './OrganizationMembershipCard';
import { PersonMembershipCard } from './PersonMembershipCard';
import type { OrganizationMembershipCardCmp_OrganizationMembership_Fragment } from './OrganizationMembershipCard';
import type { PersonMembershipCardCmp_PersonMembership_Fragment } from './PersonMembershipCard';

interface Props {
  readonly personMembership?: FragmentType<
    typeof PersonMembershipCardCmp_PersonMembership_Fragment
  >;
  readonly personMembershipAction?: ReactNode;
  readonly organizationMembership?: FragmentType<
    typeof OrganizationMembershipCardCmp_OrganizationMembership_Fragment
  >;
}

export const MembershipCard = ({
  organizationMembership,
  personMembership,
  personMembershipAction,
}: Readonly<Props>) => {
  if (organizationMembership) {
    return <OrganizationMembershipCard membership={organizationMembership} />;
  }

  if (personMembership) {
    return (
      <PersonMembershipCard
        action={personMembershipAction}
        membership={personMembership}
      />
    );
  }

  throw new Error('MembershipCard: no membership provided');
};
